//@ts-nocheck
import React, {
  forwardRef,
  useImperativeHandle,
  useEffect,
  useState,
  useContext,
} from "react";

import { Form, Input, InputNumber, Tooltip, message, Button } from "antd";
import Title from "antd/es/typography/Title";
import * as AntIcons from "@ant-design/icons";
import FormTable from "../DynamicTable/FormTable";
import useDebounce from "../../Helpers/Debounce/useDebounce";
import {
  generateReport,
  fetchReportData,
  fetchReportExcelData,
  executeReportAction,
  getInterfaceId,
  getReportId,
} from "../../Helpers/APIEndpoints/Endpoints";
import { API } from "../../Axios/Axios";
import {
  ActionHandlerProvider,
  useActionHandler,
} from "../ActionHandlerContext";
import { useAuthStore } from "../../AuthStore/AuthStore";
import { LoaderContext } from "../../Helpers/Context/Context";
import dayjs from "dayjs";
import AccessDenied from "../../Pages/AccessDenied/AccessDenied";
import { usePermission } from "../../Helpers/PermissionContext/PermissionContext";
import { pattern } from "../../Helpers/APICalls/Constants";

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType: "number" | "text";
  record: Item;
  index: number;
  children: React.ReactNode;
}

const EditableCell: React.FC<EditableCellProps> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  let inputNode;

  if (!inputType) {
    inputNode = <Input />;
  } else if (inputType === "number") {
    inputNode = <InputNumber />;
  } else {
    inputNode = <Input />;
  }

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

// Apply Loaders and Other things // Convert it into Component
//Comments also check validations on filter  on change
const DynamicReport = forwardRef(({ ...props }: any, ref) => {
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [dataConfig, setDataConfig] = useState(null);
  const [editingKey, setEditingKey] = useState(""); // NOSONAR : ignore
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [accessDenied, setAccessDenied] = useState<boolean>(false);
  const [columns, setColumns] = useState([]);
  const [filters, setFilters] = useState([]);
  const [filtersvalue, setFiltersValue] = useState();
  const [isReset, setIsReset] = useState(false);
  const [interfaceId, setInterfaceId] = useState<any>(null);
  const [reportId, setReportId] = useState<any>(null);
  const [totalcount, setTotlaCount] = useState(0);
  const [searchText, setSearchText] = useState(null);
  const debouncedSearchText = useDebounce(searchText, 2000);
  const [actionButtons, setActionButtons] = useState([]);
  const [pageButtons, setPageButtons] = useState([]);
  const [enableSearch, setenableSearch] = useState<boolean>();
  const [checkBoxFlag, setcheckBoxFlag] = useState<boolean>();
  const { rowActionHandler, reportActionHandler, autoSearchActionHandler } =
    useActionHandler();
  const { commonContextParams } = useAuthStore();
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const { HasPermission } = usePermission();

  useImperativeHandle(ref, () => ({
    reloadDashboard: async () => {
      console.log("reloadDashboard called");
      await getReportConfig();
    },
  }));

  const reportActionHandlers = {
    ...reportActionHandler, // Merge Parent's reportActionHandler
    ApplyBtnClick: async (form: any) => {
      await form?.validateFields();
      try {
        let formValue = { ...form.getFieldsValue() };
        if (formValue) {
          Object.keys(formValue).forEach((key) => {
            if (Array.isArray(formValue[key])) {
              formValue[key] = formValue[key].join(",");
            } else if (formValue[key]?.$d) {
              //This is doone as we want IST timezone
              formValue[key] = dayjs(formValue[key]).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
          });
        }

        setFiltersValue(formValue);
        getReportData(formValue);
      } catch (error) {
        console.error(error);
      }
    },
    ResetBtnfilter: (form: any) => {
      try {
        form.resetFields();
        setFiltersValue("");
        setIsReset(!isReset);
        setSearchText("");
        //clearing rowForm Data:
        getReportData();
        //message.info("Form reset successfully.");

        return;
      } catch (error) {
        console.error(error);
      }
    },
    //by kausher for quickfilter
    QuickFilterChange: async (form) => {
      await form?.validateFields();
      try {
        let formValue = { ...form.getFieldsValue() };
        if (formValue) {
          Object.keys(formValue).forEach((key) => {
            if (Array.isArray(formValue[key])) {
              formValue[key] = formValue[key].join(",");
            } else if (formValue[key]?.$d) {
              //This is doone as we want IST timezone
              formValue[key] = dayjs(formValue[key]).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
          });
        }

        setFiltersValue(formValue);
        getReportData(formValue);
      } catch (error) {
        console.error(error);
      }
    },
    //by kausher for quick filter
  };

  const getIcon = (iconName) => {
    const Icon = AntIcons[iconName];
    if (Icon) {
      return <Icon />;
    }
    // If icon name is not found, return null or a default icon (optional)
    return null;
  };

  const downloadPdf = async (formValue = null) => {
    try {
      let formValueWithFilters = {
        ...formValue,
        ...filtersvalue,
        searchText,
        desc: sortOrder === "ascend" ? 0 : 1,
        sortBy: sortField,
      };
      let response = await API.post("/DynamicReport/FetchReportPdfData", {
        UserId: commonContextParams.userId,
        RoleId: 1,
        FormData:
          formValueWithFilters != null
            ? JSON.stringify(formValueWithFilters)
            : null,
        ReportName: dataConfig?.name ?? "Report",
        ActionType: "DynamicReportActionExportToPdf",
        ReportId: reportId,
      });

      if (response.data.message != "OK") throw new Error("Download failed");

      downloadFile(
        response.data.data.fileContents,
        response.data.data.fileDownloadName,
        response.data.data.contentType
      );
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const downloadExcel = async (formValue = null, Querry = "") => {
    try {
      await showLoader();
      let formValueWithFilters = { ...formValue, ...filtersvalue, searchText };
      let response = await API.post(fetchReportExcelData, {
        UserId: commonContextParams.userId,
        RoleId: 1,
        FormData:
          formValue != null ? JSON.stringify(formValueWithFilters) : null,
        ReportName: dataConfig?.name ?? "Report",
        ActionType: "DynamicReportActionExportToExcel",
        ReportId: reportId,
        sortBy: sortField, //by kausher for sorting in excel
        desc: sortOrder === "descend", //by kausher for sorting in excel
      });

      if (response.data.message != "OK") throw new Error("Download failed");

      downloadFile(
        response.data.data.fileContents,
        response.data.data.fileDownloadName,
        response.data.data.contentType
      );
    } catch (error) {
      console.error("Error downloading file:", error);
    } finally {
      await hideLoader();
    }
  };

  function downloadFile(base64String, fileName, contentType) {
    // Convert Base64 to a binary buffer
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });

    // Create a temporary link and trigger download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  useEffect(() => {
    if (!props?.DashboardName) {
      return;
    }

    if (!reportId) {
      getReportIdBasedOnName();
      getInterfaceIdBasedOnName();
    }
  }, [props?.DashboardName, reportId]);

  const getInterfaceIdBasedOnName = async () => {
    try {
      await showLoader();
      let interfaceResponse = await API.post(getInterfaceId, {
        InterfaceName: props?.InterfaceName,
      });

      if (interfaceResponse.data.message != "OK")
        throw new Error("No InterfaceId Found");

      setInterfaceId(interfaceResponse.data.data);
    } catch (error) {
      console.error("Error getting interfaceId:", error);
    } finally {
      await hideLoader();
    }
  };

  const getReportIdBasedOnName = async () => {
    try {
      await showLoader();
      let reportResponse = await API.post(getReportId, {
        ReportName: props?.DashboardName,
      });

      if (reportResponse.data.message != "OK")
        throw new Error("No ReportId Found");

      setReportId(reportResponse.data.data);
    } catch (error) {
      console.error("Error getting report Id:", error);
    } finally {
      await hideLoader();
    }
  };

  useEffect(() => {
    if (!reportId && !commonContextParams?.roleId) {
      return;
    }
    // if (reportId && interfaceId)
    getReportConfig();
  }, [reportId]);

  const getReportConfig = async () => {
    try {
      await showLoader();
      let reportConfigResponse = await API.post(generateReport, {
        ReportId: reportId,
        InterfaceId: interfaceId,
        RoleId: commonContextParams?.roleId,
      });
      if (reportConfigResponse?.data?.data != null) {
        if (reportConfigResponse?.data?.status === 4) {
          getReportData();
          setDataConfig(reportConfigResponse?.data?.data?.config);
          setColumns(reportConfigResponse?.data?.data?.columns);
          setFilters(reportConfigResponse?.data?.data?.filters);

          setenableSearch(
            reportConfigResponse?.data?.data?.config?.enableContentSearch
          );

          const reportSetting = JSON.parse(
            reportConfigResponse?.data?.data?.config?.reportSetting
          );
          setcheckBoxFlag(reportSetting.RowSelector);

          setActionButtons(
            JSON.parse(
              reportConfigResponse?.data?.data?.config?.rowActionConfig
            )
          );
          setPageButtons(
            JSON.parse(
              reportConfigResponse?.data?.data?.config?.reportActionConfig
            )
          );
          setAccessDenied(false);
        } else {
          let message = reportConfigResponse.data?.message;
          console.error("Error:", message);
          if (message === "Unauthorized") {
            setAccessDenied(true);
          } else {
            setAccessDenied(false);
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      await hideLoader();
    }
  };

  const [searchErrorMessage, setSearchErrorMessage] = useState("");

  const handleSearch = (value) => {
    const regex = pattern;
    if (value !== "") {
      if (regex.test(value)) {
        setSearchText(value);
        setSearchErrorMessage("");
      } else {
        setSearchErrorMessage("Special characters are not allowed.");
        return;
      }
    } else {
      setSearchText("");
    }
  };

  useEffect(() => {
    const isSorting = sortField && sortOrder;
    if (isSorting && reportId) {
      // getReportData();
      getReportData(filtersvalue);// by kausher for sorting issue 
    }
  }, [sortField, sortOrder]);

  useEffect(() => {
    if (reportId) {
      getReportData(filtersvalue);
    }
  }, [debouncedSearchText]);

  const getReportData = async (
    formValue = null,
    PageSize = 10,
    PageNumber = 1
  ) => {
    try {
      await showLoader();
      let fetchResponse = await API.post(fetchReportData, {
        UserId: commonContextParams.userId,
        RoleId: 1,
        PageNumber: PageNumber,
        PageSize: PageSize,
        sortBy: sortField,
        desc: sortOrder === "descend",
        FormData: formValue != null ? JSON.stringify(formValue) : null,
        ReportId: reportId,
        SearchText: debouncedSearchText,
      });

      if (fetchResponse?.data?.data?.length > 0) {
        // Add a new key-value pair to each object inside fetchResponse.data
        const updatedData = fetchResponse.data.data.map((item) => ({
          ...item, // Spread existing object properties
          key: item?.Key,
          interfaceId: interfaceId, // Add your new key-value pair
        }));
        setTotlaCount(updatedData[0].TotalCount);

        setData(updatedData);
        setPage(PageNumber);
      } else {
        console.log("fetchResponse is empty or undefined");

        // Handle empty response scenario
        setTotlaCount(0); // Reset total count
        setData([]); // Ensure data is cleared or set to an empty array
        setPage(0);
      }
    } catch (error) {
      console.error(error);
    } finally {
      await hideLoader();
    }
  };

  const isEditing = (record: Item) => record.key === editingKey;

  const [loadingState, setLoadingState] = useState({});
  const handleActionButtonClick = async (
    button: any,
    recordId: any,
    record: any
  ) => {
    const { type } = button;

    setLoadingState((prevState) => ({
      ...prevState,
      [recordId]: { ...prevState[recordId], [type]: true },
    }));

    try {
      if (rowActionHandler[type]) {
        // Call the appropriate handler and wait for the result (if it's async)
        const result = await rowActionHandler[type](type, record);
        // Handle success
        if (result) {
          console.log(`Handler for ${type} executed successfully: ${result}`);
        }
      } else {
        console.log(`No handler found for ${type}`);
      }
    } catch (error) {
      // Handle error
      console.log(`Error executing handler for ${type}: ${error.message}`);
    } finally {
      // Set the loading state for the specific record and button to false
      setLoadingState((prevState) => ({
        ...prevState,
        [recordId]: { ...prevState[recordId], [type]: false },
      }));
    }
  };

  const handlePageActionClick = async (button: any) => { // NOSONAR : ignore
    setLoadingState((prev) => ({ ...prev, [button.label]: true }));
    try {
      await showLoader();
      // if action object is empty for buttons
      if (!button?.actions || button?.actions?.length === 0) {
        console.error(`No action found for this ${button.label} button`);
        return;
      }
      let formValue = { ...form.getFieldsValue() };

      //for export to excel call downloadExcel only
      if (button?.actionType === "DynamicReportActionExportToExcel") {
        downloadExcel(formValue, reportId);
      } else if (button?.actionType === "DynamicReportActionExportToPdf") {
        downloadPdf(formValue);
      } else {
        // for all other buttons
        for (const action of button.actions) {
          const { execType, execData } = action;
          let result;
          if (execType === "Function") {
            if (!reportActionHandler[execData]) {
              console.error(`No handler found for function: ${button.label}`);
              return;
            }
            result = await reportActionHandler[execData](button, formValue);
          } else if (execType === "Query" || execType === "SP") {
            result = await API.post(executeReportAction, {
              ReportId: reportId,
              ActionType: button.actionType,
              ActionId: action.actionId,
              FormData: JSON.stringify(formValue),
            });
            if (result?.data?.status == 1) {
              message.error(`Failed.`);
              console.log(
                button.actionId + " failed : " + result?.data?.message
              );
            } else if (result?.data?.status > 0) {
              message.warning(result?.data?.message);
            }
          } else {
            console.error(`Unsupported execType: ${execData}`);
            return;
          }
          if (!result) {
            console.error(
              `Handler for "${button.label}" executed but returned no result.`
            );
            return;
          } else {
            console.log(
              `Handler for "${button.label}" executed successfully: ${result}`
            );
          }
        }
      }
    } catch (error) {
      console.error(`No action found for this ${button.label}:`, error);
    } finally {
      setLoadingState((prev) => ({ ...prev, [button.label]: false }));
      await hideLoader();
    }
  };

  let actionColumn = "";
  if (actionButtons) {
    actionColumn = {
      title: "Actions",
      key: "actions",
      fixed: "right",
      width: 100,
      render: (_, record) => (
        <div style={{ display: "flex", gap: "0px" }}>
          {actionButtons
            ?.filter((button) =>
              typeof rowActionHandler?.[button.visibilityRules] === "function"
                ? rowActionHandler?.[button.visibilityRules](
                  button,
                  record,
                  commonContextParams
                )
                : true
            )
            .map(
              (button: any, index: number) =>
                (HasPermission(button.visibility?.edit) ||
                  HasPermission(button.visibility?.readonly)) && (
                  // <Tooltip key={index} title={button.label}>
                  <Tooltip key={index} title={
                    (record.ActionIcon === "EyeOutlined" && button.label == "Edit")
                      ? "View"
                      : (record.ActionIcon === "EditOutlined" && button.label == "Edit")
                        ? "Edit"
                        : button.label
                  }   >
                    <Button
                      id={`${HasPermission(button.visibility?.readonly)} test`}
                      disabled={
                        HasPermission(button.visibility?.edit)
                          ? false
                          : HasPermission(button.visibility?.readonly)
                      }
                      key={index}
                      icon={getIcon(button.label == "Edit" ? (record.ActionIcon ?? button.icon) : button.icon)}
                      onClick={() =>
                        handleActionButtonClick(button, record.key, record)
                      }
                      type="link"
                      //title={button.type}
                      //loading={loadingState[record.key]?.[button.type]}
                    ></Button>
                  </Tooltip>
                )
            )}
        </div>
      ),
    };
  }

  const mergedColumns = [
    ...(columns ?? []).map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        sorter: col.sort,
        sortDirections: ["ascend", "descend", "ascend"],
        //sortDirections: col.sortDirection ? JSON.parse(col.sortDirection?.replace(/'/g, '"')) : null,
        onCell: (record: Item) => ({
          record,
          inputType: col.dataIndex === "age" ? "number" : "text",
          dataIndex: col.dataIndex,
          //title: col.title,
          editing: isEditing(record),
        }),
      };
    }),
    ...(actionColumn ? [actionColumn] : []),
  ];

  // NOSONAR : ignore
  // const handleButtonClick = async (form: any, buttonConfig: any) => {
  //   try {
  //     if (buttonConfig === "reset") {
  //       form.resetFields();
  //       setFiltersValue("");
  //       setIsReset(!isReset);
  //       //clearing rowForm Data:
  //       getReportData();
  //       message.info("Form reset successfully.");
  //       return;
  //     }
  //     if (buttonConfig.actionKey.toLowerCase() === "apply") {
  //       let formValue = { ...form.getFieldsValue() };
  //       if (formValue) {
  //         Object.keys(formValue).forEach((key) => {
  //           if (Array.isArray(formValue[key])) {
  //             formValue[key] = formValue[key].join(",");
  //           } else if (formValue[key] && formValue[key].$d) {
  //             //This is doone as we want IST timezone
  //             formValue[key] = dayjs(formValue[key]).format(
  //               "YYYY-MM-DD HH:mm:ss"
  //             );
  //           }
  //         });
  //       }
  //       setFiltersValue(formValue);
  //       getReportData(formValue);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //   }
  // };

  return accessDenied ? (
    <AccessDenied />
  ) : (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          {!props?.hideTitle && (
            <div className="pageName">
              <Title level={4}>
                {dataConfig?.name}
                {/* Dynamic Head */}
              </Title>
            </div>
          )}
        </div>
        <div className="col-lg-12 mt-3">
          <Form form={form} component={false}>
            <ActionHandlerProvider
              rowActionHandler={rowActionHandler}
              reportActionHandler={reportActionHandlers}
              autoSearchActionHandler={autoSearchActionHandler}
            >
              <FormTable
                components={{
                  body: {
                    cell: EditableCell,
                  },
                }}
                filters={filters}
                rowClassName="editable-row"
                dataSource={data}
                isAddRowTable
                columns={mergedColumns}
                pageButtons={pageButtons}
                handlePageActionClick={handlePageActionClick}
                loadingState={loadingState}
                //scroll={{ x: "max-content", y: "calc(100vh - 200px)" }}
                tableCheckbox={checkBoxFlag}
                showSearchInput={enableSearch}
                handleSearch={handleSearch}
                searchValue={searchText}
                searchErrorMessage={searchErrorMessage}
                //handleButtonClick={handleButtonClick}
                pagination={{
                  total: totalcount,
                  showTotal: (totalcount, range) =>
                    `Showing ${range[0]} to ${range[1]} of ${totalcount} entries`,
                  position: ["bottomRight"],
                  pageSize: pageSize,
                  current: page,
                  showSizeChanger: true,
                  pageSizeOptions: [5, 10, 20, 50, 100],
                  onShowSizeChange: (current, size) => {
                    setPageSize(size);
                    //getReportData(null, size, current); //Commented by Pratik as this code calls onchange twice one with filter and one wothout filter which gives two different results and overrides expected output
                  },
                  onChange: (current, size) => {
                    setPageSize(size);
                    setPage(current);
                    getReportData(filtersvalue, size, current);
                  },
                }}
                onChange={(pagination, filters, sorter) => {
                  setSortField(sorter.field === undefined ? "" : sorter.field);
                  setSortOrder(
                    sorter.order === undefined ? "descend" : sorter.order
                  );
                }}
              />
            </ActionHandlerProvider>
          </Form>
        </div>
      </div>
    </div>
  );
});

export default DynamicReport;
